import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router";
import './login.css';
import Form from '../../components/form/components/Form/Form';
import FormField from '../../components/form/components/FormField/FormField';
import Button from '../../components/form/components/Button/Button';
import * as Yup from 'yup';
import AuthLayout from '../../components/form/components/Layout/AuthLayout';
import { Link } from 'react-router-dom';
import ErrorMessage from '../../components/form/components/ErrorMessage/ErrorMessage';
import { loginUser } from '../../services/auth';
// import { storeToken, getToken,isTeacher, isStudent } from '../../utils/storage';
import { storeCurrentUserId } from '../../utils/storage';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { logInWithEmailAndPassword } from '../../utils/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase/firebase-config';
import { Field } from 'formik';
import SelectFormField from '../../components/form/components/FormField/SelectFormField';
import { getUserInfo, removeCurrentUserId } from '../../utils/storage';
import { logout } from '../../utils/auth';
import BeatLoader from "react-spinners/BeatLoader";

const initialValues = {
  email: '',
  password: '',
  // role: '',
}


const override = {
  marginTop: "20px",
};

const role = [
  { label: "Admin", value: "admin" },
  { label: "User", value: "user" },

];



function Index() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [user, loading, error] = useAuthState(auth);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email(`${t('email_valid_error')}`).required(`${t('email_required_error')}`),
    password: Yup.string().min(4, `${t('password_length_error')}`).required(`${t('password_required_error')}`),
    // role: Yup.string().required("Role is required!"),
  })


  const handleSubmit =  (values: any) => {
    setIsLoading(true);

    logInWithEmailAndPassword(values.email, values.password).then(async(res) => {
      setIsLoading(false);
      if (res.user.email) {
        storeCurrentUserId(res.user.email)
      }

      //CALL METHOD TO GET USER INFO
      let data = await getUserInfo(values.email);


      if(data.role == 'admin') {
        toast.success(`${t('login_success_text')}`, {
          pauseOnHover: false,
          closeOnClick: true,
        })
        navigate("/dashboard");
      }else if(data.role == 'lab') {
        toast.success(`${t('login_success_text')}`, {
          pauseOnHover: false,
          closeOnClick: true,
        })
        navigate("/lab/home");
      }else {
        toast.error(`Not authorized`, {
          pauseOnHover: false,
          closeOnClick: true,
        })
        removeCurrentUserId();
        logout().then(() => {
          navigate('/login');
        });
        return;
      }
    
    }).catch(err => {
      setIsLoading(false);
      switch (err.code) {
        case "auth/Invalid-email":
          toast.error(`Invalid Email Address`, {
            pauseOnHover: false,
            closeOnClick: true,
          })
          break;
        case "auth/user-disabled":
          toast.error(`Account Dissabled`, {
            pauseOnHover: false,
            closeOnClick: true,
          })
          break;
        case "auth/user-not-found":
          toast.error(`Account Dissabled`, {
            pauseOnHover: false,
            closeOnClick: true,
          })
          break;
        case "auth/wrong-password":
          toast.error(`Wrong Email or Password`, {
            pauseOnHover: false,
            closeOnClick: true,
          })
          break;
        default:
          toast.error(`Error Loggin In`, {
            pauseOnHover: false,
            closeOnClick: true,
          })

      }
    })
  };


  useEffect(() => {
    if (loading) return;
    if (user) return navigate("/");
  }, [loading]);

  return (
    <AuthLayout title={t('home_welcome')} subTitle={t('login_title')}>
      <form action="" className="auth-form">
        {/* <p>{t('login_title')}</p> */}
        {error && <ErrorMessage error={error} visible={true} />}
       
        <Form
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >

          <FormField name="email" type="email" placeholder={`${t('username_label')}`} />

          <FormField name="password" type="password" placeholder={t('password_label')} />
          
          {/* <SelectFormField name="role" options={role} placeholder="Select Role" /> */}


          {!isLoading && <Button title={t('login_text')} />}
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <BeatLoader
              color="#3080ED"
              loading={isLoading}
              cssOverride={override}
            />
        </div>
        </Form>
      </form>
      <p className="u-padding-bottom-small label-link">
        {/* {t('welcome_back_text')} <Link to="/register" className="text-primary">{t('register_text')}</Link> */}
      </p>
    </AuthLayout>
  );
}

export default Index;
